import classNames from "classnames";
import React from "react";
import "./Label.css";

function Label({ children, className }) {
  return <div className={classNames("label-js", className)}>{children}</div>;
}

export default Label;
